import { useSelector } from "react-redux";

import { useEffect } from "react";
import { useMemo } from "react";
import { useState } from "react";

import { useLocation } from "react-router-dom";

import Assignment from "@mui/icons-material/Assignment";

import { MenuLink } from "../../../common-components/MenuLink/MenuLink";
import { MenuDropdown } from "../../../common-components/MenuDropdown/MenuDropdown";

const DeparturesLinks = ({ onClose }) => {
    const [isMobile, setIsMobile] = useState();
    const { pathname } = useLocation();

    const data = useSelector((state) => state.user.data);
    const permissions = data?.attributes?.role_id;
    const companyKey = data?.attributes?.rescue_company_id;

    const hasPermission = companyKey === "РЦШ ПВАСС" && (permissions === "admin" || permissions === "central_office_user");

    useEffect(() => {
        const checkIsMobile = () => setIsMobile(window.innerWidth <= 1024);
        checkIsMobile();
        window.addEventListener("resize", checkIsMobile);
        return () => window.removeEventListener("resize", checkIsMobile);
    }, []);

    const rawLinks = useMemo(
        () => [
            { title: "Выезды", active: true, show: true, link: "/Departures" },
            { title: "Количество выездов", active: true, show: hasPermission, link: "/QuantityPage" },
            { title: "Статистика", active: true, show: true, link: "/StatisticPage" },
            // { title: "Опер. карта", active: true, show: true, link: "https://resq.kz/resqcoremap" },
        ],
        [hasPermission]
    );

    const preparedLinks = rawLinks
        .map((link) => {
            if (isMobile && link.link === "/StatisticPage") {
                return { ...link, active: false };
            }
            return link;
        })
        .filter((link) => link.show);

    const links = preparedLinks.map((link) => {
        // текущий маршрут: точное совпадение или вложенный путь
        const isCurrent =
            pathname === link.link || pathname.startsWith(link.link + "/");

        const wrapperClass =
            "menu-link-wrap" +
            (isCurrent ? " _current" : "") +
            (!link.active ? " _disabled" : "");

        const handleNavigate = () => {
            onClose && onClose();
        };

        return (
            <div key={link.link} className={wrapperClass}>
                <MenuLink
                    title={link.title}
                    active={link.active} // доступность пункта
                    show={link.show}
                    link={link.link}
                    onNavigate={handleNavigate}
                />
            </div>
        );
    });

    return (
        <>
            <style>{`
        .menu-link-wrap { position: relative; border-radius: 7px; padding: 0 7px}
        .menu-link-wrap._current {
          background-color: #ecf3ff;
        }
        .menu-link-wrap._disabled { opacity: 0.5; }
      `}</style>

            <MenuDropdown
                Icon={Assignment}
                title={"Опер. выезды"}
                active={true}
                links={links}
            />
        </>
    );
};

export default DeparturesLinks;